export default "__VITE_ASSET__2887e170__"